import React, { useState } from 'react';
import { Home, Mic, Speaker, Settings, Menu, X, LogOut } from 'lucide-react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { FirebaseProvider } from './firebase/FirebaseContext';
import { AuthProvider } from './firebase/AuthContext';
import { useAuth } from './firebase/AuthContext';
import TTSPlayground from './TTSPlayground/TTSPlayground';
import SpeechToSpeech from './SpeechToSpeech/SpeechToSpeech';
import FineTuning from './Finetuning/Finetuning';
import CreateVoice from './Finetuning/CreateVoice';
import VoiceModelDetails from './Finetuning/VoiceModelDetails';
import Dashboard from './Dashboard/Dashboard';
import Login from './auth/Login';
import Register from './auth/Register';
import ProtectedRoute from './auth/ProtectedRoute';
import Sidebar from './Sidebar';
import Developer from './Developer/Developer';
import Subscription from './Subscription/Subscription';

const TTSDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // Navigation links
  const navLinks = [
    // { name: 'Home', icon: <Home size={20} />, path: '/' },
    { name: 'TTS Playground', icon: <Speaker size={20} />, path: '/' },
    // { name: 'Speech-to-Speech', icon: <Mic size={20} />, path: '/speech-to-speech' },
    { name: 'Voice Fine-Tuning', icon: <Settings size={20} />, path: '/finetune' },
  ];

  // Toggle sidebar visibility on mobile
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Get current page title


  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <div className="flex h-screen">
      {/* Mobile sidebar toggle */}
      <div className="lg:hidden fixed top-4 left-4 z-20">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-md bg-white shadow-md text-gray-700"
        >
          {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Sidebar */}
    <Sidebar user={user}/>

      <div className="flex-1 overflow-auto">

        <main className="">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  {/* <Dashboard /> */}
                  <TTSPlayground />
                </ProtectedRoute>
              }
            />
     
            <Route
              path="/speech-to-speech"
              element={
                <ProtectedRoute>
                  <SpeechToSpeech />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer"
              element={
                <ProtectedRoute>
                  <Developer />
                </ProtectedRoute>
              }
            />

            <Route
              path="/subscription"
              element={
                <ProtectedRoute>
                  <Subscription />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/finetune"
              element={
                <ProtectedRoute>
                  <FineTuning />
                </ProtectedRoute>
              }
            />
            <Route
              path="/finetune/create"
              element={
                <ProtectedRoute>
                  <CreateVoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/finetune/:modelId"
              element={
                <ProtectedRoute>
                  <VoiceModelDetails />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
      </div>
    </div>
  );
};

// Wrap the app with Router, FirebaseProvider, and AuthProvider
const App = () => (
  <FirebaseProvider>
    <AuthProvider>
      <Router>
        <TTSDashboard />
      </Router>
    </AuthProvider>
  </FirebaseProvider>
);

export default App;